import { t } from 'i18next';
import { useMutation, useQuery } from 'react-query';

import { FormActions, NotificationPosition } from 'coreOld/enums';
import { useHandleErrors, useInfiniteQuery } from 'coreOld/hooks';
import { actionLoadingMessage, actionMessage } from 'coreOld/utils';
import { jobService } from 'jobsOld/services';
import {
  IJob,
  IJobAttachmentFiltersParams,
  IJobAttachmentRequestPayload,
  IJobListRequestPayload,
} from 'jobsOld/types';

export const useGetJobList = (requestPayload?: IJobListRequestPayload) =>
  useInfiniteQuery<IJob>(jobService.getMany, 'jobs', requestPayload);

export const useGetJobAttachments = (criteria: IJobAttachmentFiltersParams, enabled?: boolean) => {
  const requestPayload: IJobAttachmentRequestPayload = {
    filters: criteria,
  };

  const { data, isLoading, isError, error } = useQuery(
    ['jobAttachments', criteria],
    ({ signal }) => jobService.getAttachments(requestPayload, signal),
    {
      keepPreviousData: false,
      enabled,
    }
  );

  return {
    records: data?.records ?? null,
    count: data?.count ?? 0,
    isLoading,
    isError,
    statusCode: (error as any)?.response?.status ?? null,
  };
};

export const useJobActions = () => ({
  ...useUpsertJobsWithAttachments(),
});

const useUpsertJobsWithAttachments = () => {
  // eslint-disable-next-line no-restricted-syntax
  const { errors } = useHandleErrors(
    actionMessage(t('labelJobs')),
    actionLoadingMessage(t('labelJobs')),
    NotificationPosition.TOP,
    null,
    FormActions.UPSERT
  );

  const { mutateAsync } = useMutation((data) => jobService.upsertJobsWithAttachments(data), {
    ...errors,
  });

  const upsertJobsWithAttachments = (data) => mutateAsync(data);

  return { upsertJobsWithAttachments };
};
